module.exports = __webpack_public_path__ + "static/media/indexBg3.45612c2c.jpg";